import {fullDate} from '../../../src/utils/dates.ts';
import {t} from '../../lib/i18n.ts';
import type {ReaderEdition} from '../../models/reader-edition.ts';

export function renderFrontPage(frontPageEl: HTMLElement, readerEdition: ReaderEdition) {
	frontPageEl.innerHTML = `
<div class="card front-page-card">
	<div class="edition-header">
		<a href="${readerEdition.getLatestEditionPath()}" class="product-name">${readerEdition.productTitle}</a>
		<div class="publish-date">${readerEdition.publishDate ? fullDate(readerEdition.publishDate, readerEdition.locale) : readerEdition.description}</div>
	</div>
	<p class="mode-touch swipe-contents-info"><span class="icon icon--swipe-right"></span>${t('swipeRight')}</p>
	<p class="mode-touch swipe-contents-info"><span class="icon icon--swipe-up"></span>${t('swipeUp')}</p>
	<div class="edition-nav-info">
		<p class="mode-keyboard">${t('nextPageHint')
			.replace(
				'{button}',
				`<button type="button" data-action="next-card" class="button"><span class="button__label">${t('nextPage')}</span> <span class="button__extra">→</span></button>`
			)
			.replace('{key}', '<kbd>→</kbd>')}</p>
		<p class="mode-touch previous-card-info"><span class="icon icon--tap"></span>${t('goBack')}</p>
		<p class="mode-touch next-card-info"><span class="icon icon--tap"></span>${t('goForward')}</p>
	</div>
</div>
<div class="article-actions">
	<div class="article-action" data-action="show-toc">${t('tableOfContents')}</div>
	<div class="article-action" data-action="next-article">${t('nextArticle')}</div>
</div>
`;
}
